// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"95184ba1","188":"39486039","482":"9b421b57","674":"f9b68c75","856":"ee5bf111","923":"fcaa068b"}[chunkId] + ".chunk.js";
};